import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TPartner } from '@src/features/users/services/partners-api';

export function PartnerFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TPartner>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      <Avatar className='size-4'>
        <AvatarImage src={item.avatar} />
        <AvatarFallback colorId={item.id}>
          {item.company_name?.[0]}
        </AvatarFallback>
      </Avatar>
      <span
        className='truncate'
        title={item.first_name}
      >
        {item.company_name}
      </span>
    </FilterOptionItem>
  );
}
